import VyberPoziceGlsStitkyDialog from "./VyberPoziceGlsStitkyDialog";

export default VyberPoziceGlsStitkyDialog.create({});



// WEBPACK FOOTER //
// ./src/components/common/vyberPoziceGlsStitkyService/index.js